export default __webpack_public_path__ + "static/media/contests.7f17d92f.png";